import { applicationCapabilitiesStore } from "./capabilities/ApplicationCapabilitiesStore";
import { applicationUiStore, normalizeUiOverride } from "./ui/ApplicationUiStore";
class ApplicationRuntime {
    unsubscribe = null;
    setFeatureFlags(options) {
        this.unsubscribe?.();
        // Subscribe first so any synchronous fire during subscription setup
        // is coalesced by invalidateCache's microtask debounce rather than
        // causing a second notification after setFeatureFlags.
        if (options.subscribe) {
            const onStoreChange = () => {
                applicationCapabilitiesStore.invalidateCache();
            };
            this.unsubscribe = options.subscribe(onStoreChange);
        }
        else {
            this.unsubscribe = null;
        }
        applicationCapabilitiesStore.setFeatureFlags(options.featureFlags);
    }
    setContext(context) {
        applicationCapabilitiesStore.batch(() => {
            applicationCapabilitiesStore.setApplicationDefinition(context.applicationDefinition);
            applicationCapabilitiesStore.setViewer(context.viewer);
            applicationCapabilitiesStore.setPlatform(context.platform);
        });
        applicationUiStore.update(normalizeUiOverride(context.applicationDefinition?.ui));
    }
    updateFeatureFlags(featureFlags) {
        applicationCapabilitiesStore.setFeatureFlags(featureFlags);
    }
    invalidateFeatureFlags() {
        applicationCapabilitiesStore.invalidateCache();
    }
    reset() {
        this.unsubscribe?.();
        this.unsubscribe = null;
        applicationCapabilitiesStore.setFeatureFlags(null);
    }
}
export const applicationRuntime = new ApplicationRuntime();
